import { SHOW_REFERRALS, HIDE_REFERRALS } from './types'


export const showReferrals = () => dispatch => {
   
        dispatch({
            type: SHOW_REFERRALS, 
            payload: true
        })
}

export const hideReferrals = () => dispatch => {
    dispatch({
        type: HIDE_REFERRALS,
        payload: false
    })
}


// WEBPACK FOOTER //
// ./src/Actions/showReferralsAction.js